import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { ResumeDataByID } from '@edtech-ui/core/models/resume-builder/get-resume-by-id';

@Component({
  selector: 'app-professional-template',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './professional-template.component.html',
  styleUrl: './professional-template.component.scss'
})
export class ProfessionalTemplateComponent {

   @Input() data!: ResumeDataByID;
    @Input() color: string = '#000';
    @Input() font: string = '';

}
